export default __webpack_public_path__ + "static/media/sohamderoy.9bec07e3.png";